'use strict';

let informationMetrics = [
  {
    module: 'Node',
    name: 'Chain_Id',
  },
  {
    module: 'Node',
    name: 'Server_Version',
  },
  {
    module: 'AtomicAssets',
    name: 'Version',
  },
  {
    module: 'AtomicAssets',
    name: 'AssetsVersion',
  },
  {
    module: 'AtomicAssets',
    name: 'MarketVersion',
  },
  {
    module: 'AtomicAssets',
    name: 'ToolsVersion',
  },
  {
    module: 'AtomicAssets',
    name: 'PostgresStatus',
  },
  {
    module: 'AtomicAssets',
    name: 'RedisStatus',
  },
  {
    module: 'AtomicAssets',
    name: 'ChainStatus',
  },
  {
    module: 'Hyperion',
    name: 'Version',
  },
  {
    module: 'Hyperion',
    name: 'StreamingFeatures',
  },
  {
    module: 'Hyperion',
    name: 'TableFeatures',
  },
  {
    module: 'Hyperion',
    name: 'IndexFeatures',
  },
  {
    module: 'Hyperion',
    name: 'TrxFeatures',
  },
  {
    module: 'Hyperion',
    name: 'ResourceFeatures',
  },
  {
    module: 'Hyperion',
    name: 'NodeosRPCStatus',
  },
  {
    module: 'Hyperion',
    name: 'RabbitMqStatus',
  },
  {
    module: 'Hyperion',
    name: 'ElasticSearchStatus',
  },
];

let endpointMetrics = [
  {
    module: 'Node',
    name: 'Connects',
  },
  {
    module: 'Hyperion',
    name: 'Connects',
  },
  {
    module: 'AtomicAssets',
    name: 'Connects',
  },
];

let producerMetrics = [
  { module: 'Producer', name: 'Rank' },
  { module: 'Producer', name: 'ActiveProducerHasProduced' },
  { module: 'Producer', name: 'ProducerSchedule' },
  { module: 'Producer', name: 'SigningKeys' },
  { module: 'Producer', name: 'LastProducedBlockNumber' },
  { module: 'Producer', name: 'LastProducedBlockTime' },
  { module: 'Producer', name: 'TotalVotes' },
  { module: 'Producer', name: 'VotePercentage' },
  { module: 'Producer', name: 'RegisteredFinalizerSigningKeys' },
  { module: 'Producer', name: 'ActiveFinalizerSigningKey' },
  { module: 'Producer', name: 'CPU_Execution_Time' },
];

export function isInformationMetric(module, name) {
  return informationMetrics.some(
    (metric) => metric.module === module && metric.name === name
  );
}

export function isEndpointMetric(module, name) {
  return endpointMetrics.some(
    (metric) => metric.module === module && metric.name === name
  );
}

export function isProducerMetric(module, name) {
  return producerMetrics.some(
    (metric) => metric.module === module && metric.name === name
  );
}
